import axiosInstance from "./axiosInstance";
import APIEndpoint from "./endpoint";



export const getListAge = async () => {
    const url = `${APIEndpoint.GET_LIST_WORK_AGE}`;
    console.log(url)
    const res = await axiosInstance.get(url);
    return res;
}

export const getListIndustry = async () => {
  const url = `${APIEndpoint.GET_LIST_INDUSTRY}`;
  console.log(url)
  const res = await axiosInstance.get(url);
  return res;
}
export const getListFutureIndustry = async () => {
  const url = `${APIEndpoint.GET_LIST_FUTURE_INDUSTRY}`;
  console.log(url)
  const res = await axiosInstance.get(url);
  return res;
}

export const getListYear = async () => {
  const url = `${APIEndpoint.GET_LIST_YEAR_OF_BUDGET}`;
  console.log(url)
  const res = await axiosInstance.get(url);
  return res;
}

export const getListYearFuture = async () => {
  const url = `${APIEndpoint.GET_LIST_YEAR_OF_BUDGET_FUTURE}`;
  console.log(url)
  const res = await axiosInstance.get(url);
  return res;
}

export let searchVoc = async (searchValue, pageValue) => {
    const api = APIEndpoint.SEARCH_LIST_VOC_REPORT;
    let payload = {
      requestObject: {
        customerGroupByAge: searchValue.customerGroupByAge ? searchValue.customerGroupByAge : "",
        lineOfWorkId: searchValue.lineOfWorkId ? searchValue.lineOfWorkId : "",
      },
      pageValue: {
        page: pageValue.page,
        pageSize: pageValue.pageSize,
        sortBy: pageValue.sortBy,
        sortDirection: pageValue.sortDirection,
      },
    };
  
    const res = axiosInstance.post(api, payload);
    return res;
  };

  export let getDetailVocReport = async(searchValue) =>{
    const api = APIEndpoint.GET_CURRENT_DETAIL_VOC_REPORT;
    let payload = {
      requestObject: {
        customerGroupByAge : searchValue.customerGroupByAge ? searchValue.customerGroupByAge : "",
        lineOfWorkId : searchValue.lineOfWorkId ? searchValue.lineOfWorkId : "",
        yearOfBudget : searchValue.yearOfBudget ? searchValue.yearOfBudget : "",
        quarter : searchValue.quarter ? searchValue.quarter : "",
      },
    };
    const res = axiosInstance.post(api,payload);
    return res;


  }

  export let getFutureDetailVocReport = async(searchValue) =>{
    const api = APIEndpoint.GET_FUTURE_DETAIL_VOC_REPORT;
    console.log(searchValue);
    let payload = {
      requestObject: {
        // TypeFuture : searchValue.TypeFuture ? searchValue.TypeFuture : "future_industry_type",
        typeFuture : searchValue?.TypeFuture ?? "future_industry_type",
        industryType : searchValue.industryType ? searchValue.industryType : "",
        yearOfBudget : searchValue.yearOfBudget ? searchValue.yearOfBudget : "",
        quarter : searchValue.quarter ? searchValue.quarter : "",
      },
    };
    console.log('payload :',payload)
    const res = axiosInstance.post(api,payload);
    return res;


  }
